<template>
    <div>
        <SaveTrimBeforeLeaveModal v-if="displaySaveTrimBeforeLeaveModal"
                            @closeModal="closeSaveTrimBeforeLeaveModal"
                            @cancel="duplicateTrim"
                            @saved="duplicateTrim"
        ></SaveTrimBeforeLeaveModal>

        <template v-if="displayAddTrimModal">
            <DuplicateTrimModal v-if="isDuplicate"
                                @closeModal="closeAddTrimModal"
                                @newTrimWasAdded="closeAddTrimModal"
            ></DuplicateTrimModal>
            <CreateNewTrimModal v-else
                             @closeModal="closeAddTrimModal"
                             @newTrimWasAdded="closeAddTrimModal"
            ></CreateNewTrimModal>
        </template>


        <ButtonCircle @click="openSaveTrimBeforeLeaveModal" :title="isDuplicate ? 'Duplicate trim' : 'Create new trim'">
            <i v-if="isDuplicate" class="icon-docs"></i>
            <i v-else class="icon-plus"></i>
        </ButtonCircle>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import SaveTrimBeforeLeaveModal from "../../components/modals/SaveTrimBeforeLeaveModal";
    import ButtonCircle from "../../components/ButtonCircle";
    import DuplicateTrimModal from "../../components/modals/DuplicateTrimModal";
    import CreateNewTrimModal from "../../components/modals/CreateNewTrimModal";
    
    export default {
        name: "CreateNewTrim",
        
        components: {
            CreateNewTrimModal,
            DuplicateTrimModal,
            ButtonCircle,
            SaveTrimBeforeLeaveModal,
        },

        props: [
            'isDuplicate',
        ],

        data() {
            return {
                displaySaveTrimBeforeLeaveModal: false,
                displayAddTrimModal: false,
            }
        },

        computed: {
            ...mapGetters('editor', [
                'trimEditDisabled',
            ]),

        },

        methods: {
            openSaveTrimBeforeLeaveModal() {
                if (this.trimEditDisabled) {
                    // ignore trim saving
                    this.duplicateTrim();
                }
                else {
                    this.displaySaveTrimBeforeLeaveModal = true;
                }
            },

            closeSaveTrimBeforeLeaveModal() {
                this.displaySaveTrimBeforeLeaveModal = false;
            },

            openAddTrimModal() {
                this.displayAddTrimModal = true;
            },

            closeAddTrimModal() {
                this.displayAddTrimModal = false;
            },

            duplicateTrim() {
                this.closeSaveTrimBeforeLeaveModal();

                this.$nextTick(this.openAddTrimModal);
            },

        },
        
    }
</script>

<style scoped>
    button {
        margin: 0 5px;
    }
</style>